import { getOffsetRelativeTo } from "../../../utilities/getOffsetRelativeTo";

/**
 * Scrolls to the specified tab if the tab is not fully in view.
 * @param scrollArea The scroll area element.
 * @param element The element to scroll to.
 */
export function scrollToElementIfNotInView(scrollArea: HTMLElement, element: HTMLElement): void {
  const { width: scrollWidth } = scrollArea.getBoundingClientRect();
  const { width } = element.getBoundingClientRect();
  const { left } = getOffsetRelativeTo(element, scrollArea);

  if (left < 0) {
    scrollArea.scrollBy(left, 0);
  } else if (left + width > scrollWidth) {
    scrollArea.scrollBy(left + width - scrollWidth, 0);
  }
}
